<template>
  <router-link
    class="back-link"
    :to="routeTo"
  >
  <svg       class="back-link__icon">
          <use :xlink:href="`#${chevron}`" />
        </svg>
    <span>{{ text || $t('common.actions.back') }}</span>
  </router-link>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import chevron from '@/assets/icons/chevron.svg'

  export default defineComponent({
    name: 'BackLink',

    props: {
      text: {
        type: String,
        required: false,
        default: '',
      },
      routeTo: {
        type: [String, Object],
        required: true,
      },
    },

    setup() {
      return {
        chevron,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .back-link {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    color: $clr-primary;
    margin-bottom: 1rem;

    &__icon {
      transform: rotate(270deg);
      width: 16px;
      height: 16px;
    }
  }
</style>
